import React, { useEffect, useState } from "react";


import {
  addToCart,
  openMiniCart,
} from "../../../redux/actions/addToCartAction";
import { useDispatch } from "react-redux";
import { addProductToCart } from "../../../helpers/cartHelpers";
import { useSelector } from "react-redux";
import { setCart } from "../Nosto"

import styles from "../../common/AddToBag/AddToBag.module.scss";

import AddToWishlist from "../AddToWishlist";
import { KlaviyoUserCartDetails } from "../Klaviyo";
import { pushAddToCartEvent, pushCartUpdateEvent } from "@/helpers/cartEventHelper";
import { setEstimatedShip, setGroupShipDate } from "@/helpers/checkout-shipping/checkoutShippingHelper";
import {algoliaConversionTracking} from "@/helpers/productHelper";
import { generalConstants } from "@/utils/constants";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { checkIfFastShippingVariant } from "@/helpers/pdpHelpers/pdpVariantHelpers";

export default function AddToBag({
  stickyProductBox,
  finalProductPrice,
  product,
  isSizeDropdownOpen,
  setIsSizeDropdownOpen,
  selectedVariant,
  isSizeSelected,
  isFavourite,
  setIsFavourite,
  setSelectedColor,
  setSelectedLetter,
  setSelectedSize,
  badgeCurated,
  hasClass,
  addToBagButtonRef,
  handleAddToBagOverlayObject,
  ...props
}) {
  const cart_list = useSelector((state) => state.click.cart_list);
  let logUser = useSelector((state) => state.loginUser);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [clicked, setOnclick] = useState(false);
  const isSoldOut = isSizeSelected
    ? !selectedVariant?.availableForSale
    : !product?.availableForSale;
  //OS-4874 attribute changes
  const isPWAApp = useSelector((state) => state.pwa.is_PWA);
  const isMobile = useMediaQuery("(max-width: 767px)");

  const availableInCountry = product?.availableInCountry;
  const isPreOrder = selectedVariant?.product?.tags?.some(tag => tag.includes(generalConstants.pre_order_tag));
  let availabilityType = product?.tags.includes(generalConstants.pre_order_tag) ?  generalConstants.pre_order : product?.tags.includes(generalConstants.available_now_tag) ? generalConstants.available_now : '';
  const defaultButtonText = isSoldOut
    ? "Sold out"
    : availableInCountry? "Add to bag" 
    : isPreOrder ? "Pre order"
    : props?.engravingAdded?.engraving_text?"Add custom item to bag"

        : "Add to bag";
  const isZeroPrice = parseFloat(finalProductPrice?.replace(/[^0-9.-]/g,""))<= 0;
  const buttonClass = isSoldOut || !availableInCountry || isZeroPrice ? styles["disbaled"]: "";
  const buttonZeroPriceClass = isZeroPrice ? styles["sold-out"]: "";
  const displayHeartIcon =
    (typeof product?.tags !== "undefined" &&
      (product?.tags?.includes("sample") || product?.tags?.includes("gift"))) ||
      isSoldOut
      ? false
      : true;
  const [buttonText, setButtonText] = useState(defaultButtonText);

  const addToBag = async (value) => {  
    const activeElement = document.activeElement;//ada - store active element
    var addToBag = true;
    if (!isSizeSelected) {
      setIsSizeDropdownOpen(true);
      addToBag = false;
    }
    if (addToBag) {
      setLoading(true);
      //set loading state for add to bag overlay
      handleAddToBagOverlayObject("loading",true)
      let request = {
        variantId: selectedVariant?.id,
        quantity: "1",
      };
      try{
        if (selectedVariant?.barcode) {
          request.lineItemCustomAttributes = [{ key: "_upc", value: selectedVariant?.barcode.toString().replace('.00', '') }];
        }
        if (product?.vendor) {
          if(request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_vendor", value: product.vendor });
          }
          else{
            request.lineItemCustomAttributes = [{ key: "_vendor", value: product.vendor }];
          }
        }
        if (selectedVariant?.oc) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_oc", value: selectedVariant.oc.value });
          }
          else {
            request.lineItemCustomAttributes = [{ key: "_oc", value: selectedVariant.oc.value }];
          }
        }
        if (availabilityType) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_availability", value: availabilityType });
          } else {
            request.lineItemCustomAttributes = [{ key: "_availability", value: availabilityType }];
          }
        } else {
          reportError("Product missing availability tag", product?.id);
        }
        
        if (badgeCurated) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_badge_curated", value: badgeCurated });
          } else {
            request.lineItemCustomAttributes = [{ key: "_badge_curated", value: badgeCurated }];
          }
        }
        //adds line item properties required for engraving
        if(props?.engravingAdded?.engraving_text){
          request?.lineItemCustomAttributes?.push({key:"Free engraving",value:props?.engravingAdded?.engraving_text});
          request?.lineItemCustomAttributes?.push({key:"Engraving font",value:props?.engravingAdded?.engraving_font});
          request?.lineItemCustomAttributes?.push({key:"_engraving_olivela_cost",value:product?.engraving_cost?.value ? product?.engraving_cost?.value:"0"});
          request?.lineItemCustomAttributes?.push({key:"_engraving_lead_time",value:product?.leadShippingTime?.value ? product?.leadShippingTime?.value:"0"});
          request?.lineItemCustomAttributes?.push({key:"_LPROP",value:'Final sale'});

          //update _oc = _oc+ engraving cost 
          if (selectedVariant?.oc) {
            const finalOC = parseFloat(selectedVariant?.oc?.value) + parseFloat(product?.engraving_cost?.value ? product?.engraving_cost?.value : 0);
            if (request?.lineItemCustomAttributes && request?.lineItemCustomAttributes?.length) {
              const existingOC = request?.lineItemCustomAttributes?.findIndex(attr => attr?.key=="_oc");
              if(existingOC){
                request.lineItemCustomAttributes[existingOC].value=  finalOC.toString();
              }
            }
            else {
              request.lineItemCustomAttributes = [{ key: "_oc", value:finalOC.toString()}];
            }
          }

        }

        //If engraving is added then pass the lead shipping time to the date calculation
        if(props?.engravingAdded?.engraving_text && product.leadShippingTime?.value){
          var estimatedDeliveryDate = setGroupShipDate(selectedVariant,0,parseInt(product.leadShippingTime?.value));
          var expectedShipDate = setEstimatedShip(selectedVariant,parseInt(product.leadShippingTime?.value));
        }else{
          var estimatedDeliveryDate = setGroupShipDate(selectedVariant);
          var expectedShipDate = setEstimatedShip(selectedVariant);
        }

        if (estimatedDeliveryDate.property) {
          request.lineItemCustomAttributes.push(estimatedDeliveryDate.property)
        }
        
        if (expectedShipDate) {
          request.lineItemCustomAttributes.push(expectedShipDate)
        }

        //OS-4874 #attribute changes
        //specifying the app or web purchaseS
        request.lineItemCustomAttributes.push({ key: "_device", value: isPWAApp ? "app": isMobile ? "mobile" : "desktop" });
        if(selectedVariant?.local_item && selectedVariant?.local_item?.value){
          request.lineItemCustomAttributes.push({ key: "_local_item", value: selectedVariant.local_item.value });
        }
      
      } catch (e) {
        reportError("Add to bag error faced while pushing line items");
        reportError(e)
      }
      let response = await addProductToCart(request);
      dispatch(addToCart(response));
      dispatch(openMiniCart(true));
      setButtonText(value);
      setTimeout(() => {
        setButtonText(defaultButtonText);
      }, 3000);
      setTimeout(() => {
        dispatch(openMiniCart(false));
      }, 5000);
      await setCart(response);
      setLoading(false);
      //set loading state for add to bag overlay
      handleAddToBagOverlayObject("loading",false)
      //call the algolia search tracking function once product is added to cart
      const queryParams = new URLSearchParams(window.location.search)
      const objectID = queryParams.get("objectId");
      //only send the conversion event if object id is present
      //This is done to prevent tracking from from anywhere else expect PLP
      if(objectID){
        algoliaConversionTracking(objectID);
      }
    }
    //ada - retain focus after add to cart
    setTimeout(() => {
      activeElement.focus();
    }, 5000);
  };
  useEffect(() => {
    setButtonText(defaultButtonText);
  }, [defaultButtonText,selectedVariant]);

   //set button text
  useEffect(()=> {
    if(handleAddToBagOverlayObject && buttonText) {
      handleAddToBagOverlayObject("label", buttonText)
    }
  },[buttonText])

  useEffect(() => {
    if (clicked) {
      var data = JSON.parse(localStorage.getItem("pdp_page_view"))

      if (data) {
        // generate ga event based on the selected variant
        const gaAddToCartEvent = props?.engravingAdded?.engraving_text ? "PDP - Add custom item to bag" : checkIfFastShippingVariant(selectedVariant) ? "PDP - fast shipping add to cart" : null;
        pushAddToCartEvent(data, selectedVariant, logUser, window.location.href, gaAddToCartEvent);
        setOnclick(false)
      }
    }

    if (cart_list?.lineItems?.edges?.length) {
      pushCartUpdateEvent(cart_list);
    }
  }, [cart_list])

  useEffect(() => {
    // replace ".add-to-cart-btn" with the class name of your cart button element
    const addToCartButton = document.querySelector(".ga-add-to-bag-btn");
    // replace ".product-title" with the class name of the element containing your product name
    let productName = document.querySelector("#productName").innerHTML;
    console.log("productName: ", productName);
    // replace ".product-img" with the class name of your product img element
    // let productImageURL = document.querySelector(".product-img").src;
    // console.log("productImageURL: ", productImageURL);
    
  })

  return (
    <>
    {/* class inline is added for wishlist alignment */}
      <div className={`add-to-bag-section wishlist-alignment ${styles["button-group"]} ${hasClass ? 'pdp' : ''}`} role="group">
        <button 
          ref={addToBagButtonRef}
          tabIndex={0}
          type="button"
          className={`ga-add-to-bag-btn btn-primary small-xs small-sm normal-md btn_loading auto-addToBag-btn ${isSoldOut ? styles["sold-out"] : styles["add-to-bag-btn"]
            } ${loading ? "loading" : ""}
              ${buttonZeroPriceClass}`}
          onClick={() => {
            if (!loading && !isZeroPrice) {
              addToBag("Added to Bag");
              setOnclick(true);
            }
          }}
        >
          <span className="ga-add-to-bag-btn">{props.buttonText || buttonText}</span>
          {!isSoldOut && stickyProductBox && (
            <span className={`${styles["price"]}`}>{finalProductPrice}</span>
          )}
        </button>
        {!isSoldOut && (
          <AddToWishlist
            selectedVariant={selectedVariant}
            finalProductPrice={finalProductPrice}
            product={product}
            favouriteIconHeight={20}
            favouriteIconWidth={20}
            isSizeSelected={isSizeSelected}
            isSizeDropdownOpen={isSizeDropdownOpen}
            setIsSizeDropdownOpen={setIsSizeDropdownOpen}
            setSelectedColor={setSelectedColor}
            setSelectedLetter={setSelectedLetter}
            setSelectedSize={setSelectedSize}
            hasClass={hasClass}
            isPDP={true}
          />
        )}
      </div>
    </>
  );
}